import { render, staticRenderFns } from "./EnterpriseBigData.vue?vue&type=template&id=21377b24&scoped=true&"
import script from "./EnterpriseBigData.vue?vue&type=script&lang=js&"
export * from "./EnterpriseBigData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21377b24",
  null
  
)

export default component.exports